import {useCallback, useEffect, useRef} from 'react';

const INTERVAL = 800;

const useInterval = (cb = () => {}, interval = INTERVAL, maxRemainingTime = null) => {
  const intervalRef = useRef();
  const remainingRef = useRef(0);

  const stop = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = null;
    remainingRef.current = 0;
  }, []);

  const start = useCallback(() => {
    stop();

    intervalRef.current = setInterval(async () => {
      try {
        if (cb) cb();

        if (maxRemainingTime) {
          remainingRef.current += interval;
          if (remainingRef.current >= maxRemainingTime) {
            stop();
          }
        }
      } catch (error) {
        console.error('start interval', error);
        stop();
      }
    }, interval);
  }, [stop, interval, cb, maxRemainingTime]);

  useEffect(
    () =>
      // TODO
      () => {
        stop();
      },
    [stop],
  );

  return {
    start,
    stop,
  };
};
export default useInterval;
